import { MARK } from "../helper";

/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/
/*🤫*/

export abstract class TrackSuggestRenderTime {
  static getTime(): number | undefined {
    const performanceEntries: PerformanceEntryList = performance.getEntriesByName(MARK.SUGGEST_RENDER_TIME);
    if (performanceEntries && performanceEntries.length > 0) {
      const count: number = performanceEntries.length;
      const sum: number = performanceEntries.reduce((e, n) => e + n.duration, 0);
      return Math.round(sum / count);
    } else {
      return undefined;
    }
  }
}

export abstract class TrackSuggestTime {
  /*🤫
🤫
🤫
🤫*/
  static track(): number | null {
    const performanceMeasure: PerformanceMeasure = this.measure();
    return performanceMeasure.duration;
  }

  static getCurrentTime(): number {
    const performanceMeasure: PerformanceMeasure = this.measure();
    return parseInt(performanceMeasure.duration.toString());
  }

  static measure(): PerformanceMeasure {
    return performance.measure(MARK.SUGGEST_TIME, MARK.SUGGEST_TIME_START);
  }

  static mark() {
    performance.mark(MARK.SUGGEST_TIME_START);
  }
}

export const trackSuggestRenderTime = {
  getTime: TrackSuggestRenderTime.getTime,
};

export const trackSuggestTime = {
  track: TrackSuggestTime.track,
  getCurrentTime: TrackSuggestTime.getCurrentTime,
  measure: TrackSuggestTime.measure,
  mark: TrackSuggestTime.mark,
};
